import store from '@/state/store'
import { authGuard } from "../auth";

export default [
    {
        path: '/login',
        name: 'login',
        component: require('./views/account/login').default,
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({ name: 'default' })
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/404',
        name: '404',
        component: require('./views/utility/404').default,
    },
    // Redirect any unmatched routes to the 404 page. This may
    // require some server configuration to work in production:
    // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
    {
        path: '*',
        redirect: '404',
    },
    {
        path: '/',
        // redirect: 'tickets',
        name: 'default',
        component: require('./views/dashboards/default').default,
        beforeEnter: authGuard
    },
    {
        path: '/my-tc',
        name: 'my-tc',
        beforeEnter: authGuard,
        component: require('./views/tickets/my-tc').default
    },
    {
        path: '/tickets',
        name: 'tickets',
        beforeEnter: authGuard,
        component: require('./views/tickets/index').default
    },
    {
        path: '/tickets/unassigned',
        name: 'unassigned-tickets',
        beforeEnter: authGuard,
        component: require('./views/tickets/unassigned').default
    },
    {
        path: '/tickets/create',
        name: 'create-ticket',
        beforeEnter: authGuard,
        component: require('./views/tickets/create').default
    },
    {
        path: '/tickets/:id',
        name: 'view-ticket',
        beforeEnter: authGuard,
        component: require('./views/tickets/show').default
    },
    {
        path: '/sla-breaches',
        name: 'sla-breaches',
        beforeEnter: authGuard,
        component: require('./views/sla-breaches/index').default
    },
    {
        path: '/notifications',
        name: 'notifications',
        beforeEnter: authGuard,
        component: require('./views/notifications/index').default
    },
    {
        path: '/reporting',
        name: 'reports',
        beforeEnter: authGuard,
        component: require('./views/reporting/index').default
    },
    {
        path: '/reporting/create',
        name: 'create-report',
        beforeEnter: authGuard,
        component: require('./views/reporting/show').default
    },
    {
        path: '/reporting/:id',
        name: 'view-report',
        beforeEnter: authGuard,
        component: require('./views/reporting/show').default
    },
    {
        path: '/automated-reporting',
        name: 'automated-reports',
        beforeEnter: authGuard,
        component: require('./views/automated-reporting/index').default
    },
    {
        path: '/automated-reporting/:id/edit',
        name: 'edit-automated-report',
        beforeEnter: authGuard,
        component: require('./views/automated-reporting/edit').default
    },
    {
        path: '/automated-reporting/create',
        name: 'create-automated-report',
        beforeEnter: authGuard,
        component: require('./views/automated-reporting/create').default
    },
    {
        path: '/automated-report-result/:id',
        name: 'automated-report-result',
        beforeEnter: authGuard,
        component: require('./views/automated-report-result/show').default
    },
    // {
    //     path: '/reporting/:id',
    //     name: 'view-report',
    //     beforeEnter: authGuard,
    //     component: require('./views/reporting/show').default
    // },
    {
        path: '/settings/ticket-note-templates',
        name: 'ticket-note-templates',
        beforeEnter: authGuard,
        component: require('./views/settings/ticket-note-templates/index').default
    },
    {
        path: '/settings/ticket-note-templates/create',
        name: 'create-ticket-note-template',
        beforeEnter: authGuard,
        component: require('./views/settings/ticket-note-templates/create').default
    },
    {
        path: '/settings/ticket-note-templates/:id/edit',
        name: 'edit-ticket-note-template',
        beforeEnter: authGuard,
        component: require('./views/settings/ticket-note-templates/edit').default
    },
    {
        path: '/settings/ticket-note-templates',
        name: 'ticket-note-templates',
        beforeEnter: authGuard,
        component: require('./views/settings/ticket-note-templates/index').default
    },
    {
        path: '/settings/ticket-note-templates/create',
        name: 'create-ticket-note-template',
        beforeEnter: authGuard,
        component: require('./views/settings/ticket-note-templates/create').default
    },
    {
        path: '/settings/ticket-note-templates/:id/edit',
        name: 'edit-ticket-note-template',
        beforeEnter: authGuard,
        component: require('./views/settings/ticket-note-templates/edit').default
    }, {
        path: '/settings/ticket-email-templates',
        name: 'ticket-email-templates',
        beforeEnter: authGuard,
        component: require('./views/settings/ticket-email-templates/index').default
    },
    {
        path: '/settings/ticket-email-templates/create',
        name: 'create-ticket-email-template',
        beforeEnter: authGuard,
        component: require('./views/settings/ticket-email-templates/create').default
    },
    {
        path: '/settings/ticket-email-templates/:id/edit',
        name: 'edit-ticket-email-template',
        beforeEnter: authGuard,
        component: require('./views/settings/ticket-email-templates/edit').default
    },
    {
        path: '/settings/ticket-templates',
        name: 'ticket-templates',
        beforeEnter: authGuard,
        component: require('./views/settings/ticket-templates/index').default
    },
    {
        path: '/settings/ticket-templates/create',
        name: 'create-ticket-template',
        beforeEnter: authGuard,
        component: require('./views/settings/ticket-templates/create').default
    },
    {
        path: '/settings/ticket-templates/:id/edit',
        name: 'edit-ticket-template',
        beforeEnter: authGuard,
        component: require('./views/settings/ticket-templates/edit').default
    },
    {
        path: '/settings/slas',
        name: 'edit-slas',
        beforeEnter: authGuard,
        component: require('./views/settings/slas/index').default
    },
    {
        path: '/settings/autoresponder',
        name: 'edit-autoresponder-settings',
        beforeEnter: authGuard,
        component: require('./views/settings/autoresponder/index').default
    },
    {
        path: '/settings/twilio-phone-numbers',
        name: 'twilio-phone-numbers',
        beforeEnter: authGuard,
        component: require('./views/settings/twilio-phone-numbers/index').default
    },
    {
        path: '/settings/twilio-phone-numbers/create',
        name: 'create-twilio-phone-number',
        beforeEnter: authGuard,
        component: require('./views/settings/twilio-phone-numbers/create').default
    },
    {
        path: '/settings/twilio-phone-numbers/:id/edit',
        name: 'edit-twilio-phone-number',
        beforeEnter: authGuard,
        component: require('./views/settings/twilio-phone-numbers/edit').default
    },
    {
        path: '/settings/offices',
        name: 'offices',
        beforeEnter: authGuard,
        component: require('./views/settings/offices/index').default
    },
    {
        path: '/settings/offices/create',
        name: 'create-office',
        beforeEnter: authGuard,
        component: require('./views/settings/offices/create').default
    },
    {
        path: '/settings/offices/:id/edit',
        name: 'edit-office',
        beforeEnter: authGuard,
        component: require('./views/settings/offices/edit').default
    },
    {
        path: '/settings/tag-templates',
        name: 'tag-templates',
        beforeEnter: authGuard,
        component: require('./views/settings/tag-templates/index').default
    },
    {
        path: '/settings/tag-templates/create',
        name: 'create-tag-template',
        beforeEnter: authGuard,
        component: require('./views/settings/tag-templates/create').default
    },
    {
        path: '/settings/tag-templates/:id/edit',
        name: 'edit-tag-template',
        beforeEnter: authGuard,
        component: require('./views/settings/tag-templates/edit').default
    },
    {
        path: '/settings/users',
        name: 'users',
        beforeEnter: authGuard,
        component: require('./views/settings/users/index').default
    },
    {
        path: '/settings/users/:id/edit',
        name: 'edit-user',
        beforeEnter: authGuard,
        component: require('./views/settings/users/edit').default
    },
    {
        path: '/profile',
        name: 'profile',
        beforeEnter: authGuard,
        component: require('./views/profile/edit').default
    }
]
